module.exports = __webpack_public_path__ + "static/img/ico-saly.89d2c973.png";